module.exports = __webpack_public_path__ + "img/AO.5ecb47d2.svg";